import { GetStaticPropsContext } from "next";
import React from "react";
import { withAppLayout } from "components/core/withAppLayout";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "./../../../next-i18next.config";
import { getIndustriesPage } from "queries/Industry";
import { createSubscription } from "components/hooks/usePreview";
import CtaBlock, { ICtaBlock } from "blocks/cta/CtaBlock";
import BlockMapper from "blocks/BlockMapper";
import Container from "components/core/Container";
import Card from "components/base/Card";
import { IImage, ILink, PageSlug } from "types/base";

export async function getStaticProps(context: GetStaticPropsContext) {
    const query = {
        query: getIndustriesPage(context.locale),
        preview: context.preview,
        withAppData: true,
        locale: context.locale
    };

    const data = await createSubscription(context, query);

    return {
        props: {
            data: data,
            seo: data.initialData?.industry?.seo,
            industryPage: data.initialData?.industry,
            appData: {
                ...data.initialData.header,
                ...data.initialData.footer,
            },
            ...(await serverSideTranslations(context.locale, ['common'], nextI18NextConfig)),
        }
    };
}

type IIndustryPageItem = {
    id: string;
    title: string;
    intro: any;
    featuredImage: IImage;
    page: {
        slug: string
    };
};

type IIndustryPage = {
    id: string;
    content: any;
    cta: ICtaBlock;
};

type Props = {
    industry: IIndustryPage;
    allIndustryPages: IIndustryPageItem[];
};
function Index(props: Props) {
    const { allIndustryPages } = props;
    const { content, cta } = props.industry;

    return (
        <>
            {/* Quick fix, we need to change this once we have spacing objects... */}
            {content.map((block: any, index: number) => Object.keys(block).length > 0 && (
                <div key={'content-item-' + index}>
                    <div className={"h-28"} hidden={index === 0}>&nbsp;</div>
                    <BlockMapper key={block.id} {...block} />
                </div>
            ))}

            <section>
                <Container>
                    <div className={"grid grid-cols-1 gap-8 mt-4 lg:gap-6 lg:grid-cols-3 lg:gap-12 mb-10"}>
                        {allIndustryPages.filter(p => p.title).map(page => {
                            return (
                                <Card
                                    key={page.id}
                                    title={page.title}
                                    featuredImage={page.featuredImage}
                                    slug={page.page.slug}
                                    intro={page.intro}
                                />
                            );
                        })}
                    </div>
                </Container>
            </section>

            {cta && (
                <section>
                    <CtaBlock {...cta} />
                </section>
            )}
        </>
    );
}

export default withAppLayout(Index);